// extracted by mini-css-extract-plugin
export default {"logo":"Navbars_logo__QUFiG"};